import { createContext } from "react";
import type useTrialInstitutionIdentityById from "src/hooks/data/load/useTrialInstitutionIdentityById";

export interface ITrialInstitutionIdentityContext extends ReturnType<
    typeof useTrialInstitutionIdentityById
> {}

export const TrialInstitutionIdentityContext = createContext<ITrialInstitutionIdentityContext>({
    data: undefined,
    error: undefined,
    loading: false,
    validating: false,
    mutate: async () => undefined,
    refresh: async () => undefined,
});

export default TrialInstitutionIdentityContext;
